import 'vue-svgicon/dist/polyfill';
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
import Vue from 'vue';
import VueSVGIcon from 'vue-svgicon';
import App from './App.vue';
import router from './router';
import { i18n, setLanguage } from './plugins/i18n';
import store from './store';
import vuetify from './plugins/vuetify';
import hasPermission from './helpers/hasPermission';

// Sentry.init({
//   dsn: 'https://7d263ef7d9e442318431005734a314a6@sentry.iskytest.com/3',
//   integrations: [new Integrations.Vue({ Vue, attachProps: true })],
// });

Vue.config.productionTip = false;

Vue.use(VueSVGIcon);
Vue.prototype.$can = hasPermission;

setLanguage().then(() => {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
});
